/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Level_Switcher_LabelInputs */

const en_level_switcher_label = /** @type {(inputs: Level_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor`)
};

const fr_level_switcher_label = /** @type {(inputs: Level_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étage`)
};

const ms_sg2_level_switcher_label = /** @type {(inputs: Level_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat`)
};

/**
* | output |
* | --- |
* | "Floor" |
*
* @param {Level_Switcher_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const level_switcher_label = /** @type {((inputs?: Level_Switcher_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Switcher_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_level_switcher_label(inputs)
	if (locale === "fr") return fr_level_switcher_label(inputs)
	return ms_sg2_level_switcher_label(inputs)
});